// ═══════════════════════════════════════════════════════════════════
//  modules/courriel/Redaction.js
//  Redaction
// ═══════════════════════════════════════════════════════════════════

import { useEffect, useState } from "react";
import { API_BASE } from "../../socle/api";
import { THEME } from "../../socle/theme";
import { btnStyle, mailHeaders } from "./utils";

// ═══════════════════════════════════════════════════════════════════════
//  FENÊTRE DE RÉDACTION
// ═══════════════════════════════════════════════════════════════════════
export function Redaction({ token, initial, onClose, onSent }) {
  const [to, setTo] = useState(initial.to || "");
  const [subject, setSubject] = useState(initial.subject || "");
  const [body, setBody] = useState(initial.body || "");
  const [modeles, setModeles] = useState([]);
  const [envoi, setEnvoi] = useState(false);
  const [erreur, setErreur] = useState(null);
  const [accuseRemise, setAccuseRemise] = useState(false);
  const [accuseLecture, setAccuseLecture] = useState(false);

  useEffect(() => {
    fetch(`${API_BASE}/api/mail/templates`, { headers: mailHeaders(token) })
      .then((r) => (r.ok ? r.json() : []))
      .then(setModeles)
      .catch(() => setModeles([]));
  }, [token]);

  // Le prénom est déduit, dans l'ordre : de l'interlocuteur du message
  // d'origine, sinon du destinataire saisi. Un nouveau message adressé à
  // « golriver.pro@gmail.com » donne donc « Golriver ».
  const prenomDeduit = () => {
    if (initial.prenom) return initial.prenom;
    const adresse = (to || "").split(",")[0].trim();
    const local = adresse.includes("@") ? adresse.split("@")[0] : adresse;
    const mot = (local || "").split(/[._\-+]/)[0].replace(/\d+$/, "");
    return mot ? mot.charAt(0).toUpperCase() + mot.slice(1) : "";
  };

  const appliquerModele = (id) => {
    const m = modeles.find((x) => String(x.id) === String(id));
    if (!m) return;
    const prenom = prenomDeduit();
    const sujetOrigine = initial.sujetOrigine || subject.replace(/^Re:\s*/i, "");
    const remplace = (s) => {
      let t = s || "";
      // Sans prénom connu, on retire aussi l'espace qui précède, sinon on
      // obtient « Bonjour , » — le défaut visible sur le premier envoi.
      t = prenom ? t.replace(/\{prenom\}/g, prenom) : t.replace(/ ?\{prenom\}/g, "");
      return t.replace(/\{sujet\}/g, sujetOrigine);
    };
    if (m.sujet) setSubject(remplace(m.sujet));
    setBody(remplace(m.corps) + (initial.body || ""));
  };

  const envoyer = async () => {
    if (!to.trim() || !subject.trim() || !body.trim()) { setErreur("Destinataire, objet et message sont requis."); return; }
    setEnvoi(true); setErreur(null);
    try {
      const res = await fetch(`${API_BASE}/api/mail/send`, {
        method: "POST", headers: mailHeaders(token),
        body: JSON.stringify({
          to, subject, body,
          replyToUid: initial.replyToUid || null,
          accuseRemise, accuseLecture,
        }),
      });
      const json = await res.json();
      if (!res.ok || !json.success) throw new Error(json.error || "envoi impossible");
      // Le message est parti : on ferme, en signalant le cas où sa copie
      // dans « Envoyés » n'a pas pu être déposée.
      onSent(json.avertissement || null);
    } catch (e) {
      setErreur(e.message);
    } finally { setEnvoi(false); }
  };

  return (
    <div onClick={(e) => e.target === e.currentTarget && onClose()} style={{
      position: "fixed", inset: 0, background: "rgba(0,0,0,.6)", zIndex: 1000,
      display: "flex", alignItems: "center", justifyContent: "center", padding: 16,
    }}>
      <div style={{ background: THEME.surface, border: `1px solid ${THEME.border}`, borderRadius: 14,
                    width: "100%", maxWidth: 680, maxHeight: "90vh", overflowY: "auto",
                    padding: 20, boxSizing: "border-box" }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <div style={{ color: THEME.text, fontSize: 17, fontWeight: 800 }}>
            {initial.replyToUid ? "↩ Répondre" : "✎ Nouveau message"}
          </div>
          <button onClick={onClose} style={btnStyle()}>✕</button>
        </div>

        {modeles.length > 0 && (
          <select defaultValue="" onChange={(e) => appliquerModele(e.target.value)} style={{
            width: "100%", boxSizing: "border-box",
            background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8,
            padding: "9px 12px", color: THEME.text, fontSize: 13, marginBottom: 12, fontFamily: "inherit",
          }}>
            <option value="">— Utiliser un modèle de réponse —</option>
            {modeles.map((m) => <option key={m.id} value={m.id}>{m.nom}</option>)}
          </select>
        )}

        {[["Destinataire", to, setTo, "adresse@exemple.fr"], ["Objet", subject, setSubject, "Objet du message"]].map(([label, val, setter, ph]) => (
          <div key={label} style={{ marginBottom: 12 }}>
            <label style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 700, letterSpacing: ".08em" }}>{label.toUpperCase()}</label>
            <input value={val} onChange={(e) => setter(e.target.value)} placeholder={ph} style={{
              width: "100%", boxSizing: "border-box",
              background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8,
              padding: "9px 12px", color: THEME.text, fontSize: 13, outline: "none", marginTop: 5,
              fontFamily: "inherit",
            }} />
          </div>
        ))}

        <label style={{ color: THEME.textMuted, fontSize: 11, fontWeight: 700, letterSpacing: ".08em" }}>MESSAGE</label>
        <textarea value={body} onChange={(e) => setBody(e.target.value)} rows={12} style={{
          width: "100%", boxSizing: "border-box",
          background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8,
          padding: "11px 12px", color: THEME.text, fontSize: 13, outline: "none", marginTop: 5,
          fontFamily: "inherit", lineHeight: 1.55, resize: "vertical",
        }} />
        <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 6 }}>
          Ta signature personnelle est ajoutée automatiquement à l'envoi — modifiable via « Ma signature ».
        </div>

        {/* Accusés de réception — deux mécanismes distincts */}
        <div style={{ background: THEME.panel, border: `1px solid ${THEME.border}`, borderRadius: 8,
                      padding: "11px 13px", marginTop: 14 }}>
          <div style={{ color: THEME.textMuted, fontSize: 10.5, fontWeight: 800, letterSpacing: ".08em", marginBottom: 8 }}>
            ACCUSÉ DE RÉCEPTION
          </div>

          <label style={{ display: "flex", gap: 9, alignItems: "flex-start", cursor: "pointer", marginBottom: 9 }}>
            <input type="checkbox" checked={accuseRemise} onChange={(e) => setAccuseRemise(e.target.checked)}
                   style={{ marginTop: 2, accentColor: THEME.accent, cursor: "pointer" }} />
            <span>
              <span style={{ color: THEME.text, fontSize: 12.5, fontWeight: 700 }}>Accusé de remise</span>
              <span style={{ display: "block", color: THEME.textDim, fontSize: 11.5, lineHeight: 1.45 }}>
                Le serveur du destinataire confirme la bonne remise. Invisible pour lui, fiable — mais tous
                les serveurs ne le gèrent pas.
              </span>
            </span>
          </label>

          <label style={{ display: "flex", gap: 9, alignItems: "flex-start", cursor: "pointer" }}>
            <input type="checkbox" checked={accuseLecture} onChange={(e) => setAccuseLecture(e.target.checked)}
                   style={{ marginTop: 2, accentColor: THEME.accent, cursor: "pointer" }} />
            <span>
              <span style={{ color: THEME.text, fontSize: 12.5, fontWeight: 700 }}>Accusé de lecture</span>
              <span style={{ display: "block", color: THEME.textDim, fontSize: 11.5, lineHeight: 1.45 }}>
                Le destinataire voit une demande de confirmation à l'ouverture et peut la refuser. Souvent
                ignoré, et parfois mal perçu sur un premier contact.
              </span>
            </span>
          </label>

          {accuseLecture && !initial.replyToUid && (
            <div style={{ color: THEME.amber, fontSize: 11.5, marginTop: 9, lineHeight: 1.45 }}>
              Sur une prise de contact à froid, cette demande apparaît avant même que le message soit lu.
              L'accusé de remise seul est généralement préférable.
            </div>
          )}

          <div style={{ color: THEME.textDim, fontSize: 11, marginTop: 9 }}>
            Les confirmations reçues sont étiquetées « Automatique » : elles n'entrent pas dans les
            messages en attente de réponse.
          </div>
        </div>

        {erreur && <div style={{ color: THEME.red, fontSize: 12.5, marginTop: 10 }}>{erreur}</div>}

        <div style={{ display: "flex", gap: 8, justifyContent: "flex-end", marginTop: 16 }}>
          <button onClick={onClose} style={btnStyle()}>Annuler</button>
          <button onClick={envoyer} disabled={envoi} style={{ ...btnStyle(true), opacity: envoi ? .6 : 1 }}>
            {envoi ? "Envoi…" : "Envoyer"}
          </button>
        </div>
      </div>
    </div>
  );
}
